import * as angular from 'angular';

const fdCustomButtonsHtml = require('../../views/fd_custom_buttons.html');

'use strict';

angular.module('formApp').directive('fdCustomButtons', function () {
  return {
    scope: false,
    templateUrl: fdCustomButtonsHtml,
    replace: true,
    controller: 'fdCustomButtonsCtrl'
  };
});
